var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.svgIcon)?_c('div',{staticClass:"inline-block align-middle"},[_c('span',{class:_vm.svgFill,domProps:{"innerHTML":_vm._s(_vm.svgIcon)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }